/* Sticky Buy Bar */
(function () {
  var panel = document.querySelector('[data-sticky-buy-panel]');
  if (!panel) return;

  var sectionId = panel.getAttribute('data-section-id');
  var formTarget = panel.getAttribute('data-target');
  var mainBtn = null;
  var visibilityEl = null;
  var priceEl = null;
  var priceLabel = panel.querySelector('[data-sticky-buy-price]');
  var footerZone = document.querySelector('#shopify-section-footer-promotions');
  if (!footerZone) footerZone = document.querySelector('footer.site-footer');

  if (formTarget) {
    var form = document.getElementById(formTarget.replace('#', ''));
    if (form) {
      mainBtn = form.querySelector('[data-add-to-cart]');
    }
  }
  if (mainBtn) {
    visibilityEl = mainBtn.closest('.product-block') || mainBtn;
  }

  if (sectionId) {
    var section = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (section) {
      priceEl = section.querySelector('[data-product-price]');
    }
  }

  function syncPrice() {
    if (!priceEl || !priceLabel) return;
    var text = (priceEl.textContent || '').replace(/\s+/g, ' ').trim();
    if (text) priceLabel.textContent = 'Buy for ' + text;
  }

  syncPrice();
  if (priceEl) {
    var observer = new MutationObserver(syncPrice);
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  var ticking = false;
  function check() {
    ticking = false;
    var show = false;
    if (visibilityEl) {
      var btnRect = visibilityEl.getBoundingClientRect();
      var btnOut = btnRect.bottom <= 0;
      var footerNear = false;
      if (footerZone) {
        footerNear = footerZone.getBoundingClientRect().top <= window.innerHeight;
      }
      show = btnOut && !footerNear;
    }
    panel.classList.toggle('is-visible', show);
    panel.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(check);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();

  var btn = panel.querySelector('[data-sticky-buy-scroll]');
  if (btn) {
    btn.addEventListener('click', function () {
      if (mainBtn) {
        mainBtn.click();
        return;
      }
      if (formTarget) {
        var target = document.getElementById(formTarget.replace('#', ''));
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 110;
          window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        }
      }
    });
  }
})();
